import { call, takeEvery } from '@redux-saga/core/effects';
import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER } from '../../constant/Constant';
import NullCheckUtil from '../../util/NullCheckUtil';
import { request } from '../ApiModule';

const BASE = 'file-attach';
const ACTION_FILE_UPLOAD = BASE + PATH_DELIMITER + 'ACTION_FILE_UPLOAD';
const ACTION_FILE_DOWNLOAD = BASE + PATH_DELIMITER + 'ACTION_FILE_DOWNLOAD';

export const actionFileUpload = createAction(ACTION_FILE_UPLOAD);
export const actionFileDownload = createAction(ACTION_FILE_DOWNLOAD);

export function* fileAttachSagas() {
    yield takeEvery(ACTION_FILE_UPLOAD, actionFileUploadSaga);
    yield takeEvery(ACTION_FILE_DOWNLOAD, actionFileDownloadSaga);
}

function* actionFileDownloadSaga({ payload: { params, downloadType } }) {
    yield call(request, {
        method: 'get',
        url: '/api/file/export',
        params,
        download: true,
        downloadDirect: true,
        downloadType,
    });
}

function* actionFileUploadSaga({ payload: { params, callback, uploadProgress } }) {
    const formData = new FormData();
    formData.append('file', params.file);
    const result = yield call(request, {
        method: 'post',
        url: '/api/file/import',
        data: formData,
        upload: true,
        uploadProgress,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(result);
    }
}

const initialState = {};

const module = handleActions({}, initialState);

export default module;
